import { useEffect, useRef, useState } from 'react'
import { cn } from '@/lib/utils'
import type { CardData } from '../types'
import { Card } from './Card'
import { Button } from './ui/button'

interface GameFooterProps {
  hand: CardData[]
  isPlayerTurn: boolean
  onEndTurn: () => void
  onPlayCard: (cardId: string) => void
  canEndTurn: boolean
  onInspect?: (card: CardData) => void
  selectedTheme?: 'FANTASY' | 'NOIR' | 'SUNSET'
}

export function GameFooter({
  hand,
  isPlayerTurn,
  onEndTurn,
  onPlayCard,
  canEndTurn,
  onInspect,
  selectedTheme,
}: GameFooterProps) {
  const isSunset = selectedTheme === 'SUNSET'
  const isFantasy = selectedTheme === 'FANTASY'
  const [showTurnFlash, setShowTurnFlash] = useState(false)
  const prevTurnRef = useRef(isPlayerTurn)

  useEffect(() => {
    if (isPlayerTurn && !prevTurnRef.current) {
      setShowTurnFlash(true)
      const timer = setTimeout(() => setShowTurnFlash(false), 2000)
      return () => clearTimeout(timer)
    }
    prevTurnRef.current = isPlayerTurn
  }, [isPlayerTurn])

  return (
    <footer className="h-[200px] flex items-center justify-center shrink-0 relative z-50 border-t border-white/5 bg-black/10">
      <div className="flex-1 h-full hand-container flex justify-center items-end px-12 overflow-visible">
        {hand.map((card, index) => {
          const total = hand.length
          const overlap = total > 8 ? -60 : -40

          return (
            <div
              key={card.id}
              className="hand-card-wrapper group"
              style={{
                marginLeft: index === 0 ? 0 : `${overlap}px`,
                zIndex: index + 10,
              }}
              onContextMenu={(e) => {
                e.preventDefault()
                onInspect?.(card)
              }}
              onClick={() => {
                onInspect?.(card)
              }}
            >
              <div
                className="hand-card-visual origin-bottom pointer-events-none group-hover:pointer-events-auto"
                style={{
                  transform: `translateY(30px)`,
                }}
              >
                <div
                  className="w-full h-full cursor-grab active:cursor-grabbing hover:!z-50"
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData('cardId', card.id)
                      ; (window as any)._draggedCardId = card.id
                  }}
                >
                  <Card card={card} />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </footer>
  )
}
